import React from 'react';

import { UserProfile } from 'views/User/components';

export default () => {
  return <UserProfile />;
};
